// echarts 主题（沿用历史主题名 "macarons"，实际内容已替换为 ReyVend 品牌色）。
// echarts 主题在 JS 加载时求值、无法直接引用 CSS 变量，因此这里改为「读取当前 CSS 变量」的构建函数：
// 随 [data-theme] 亮/暗自动切换颜色；背景透明，直接透出下方已主题化的面板，暗色模式下不再出现白底图表。
// 主题切换后需调用 echarts.registerTheme("macarons", buildMacarons()) 并重渲染图表（见 main.js / Header.vue）。

const cssVar = (name, fallback) => {
  try {
    const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    return v || fallback;
  } catch (e) {
    return fallback;
  }
};

// 品牌调色板（亮/暗通用）
const PALETTE = [
  "#01e1a8", "#3b82f6", "#f59e0b", "#ef4444", "#8b5cf6",
  "#06b6d4", "#f97316", "#10b981", "#6366f1", "#ec4899",
  "#84cc16", "#14b8a6", "#f43f5e", "#a855f7", "#0ea5e9",
  "#d946ef", "#22c55e", "#eab308", "#64748b", "#78716c"
];

export function buildMacarons() {
  const ink = cssVar("--vtm-ink", "#1b2b3a"); // 主文本
  const ink2 = cssVar("--vtm-ink-2", "#486581"); // 次级文本/轴标签
  const line = cssVar("--vtm-line", "#e4e7eb"); // 分隔线
  const well = cssVar("--vtm-well", "#f1f2f4"); // 网格/浅背景
  const surface = cssVar("--vtm-surface", "#ffffff"); // 提示框背景
  const mint = cssVar("--vtm-mint", "#01e1a8");
  const mintDim = cssVar("--vtm-mint-dim", "#00c492");
  const crit = cssVar("--vtm-crit", "#c7233f");

  return {
    color: PALETTE.slice(),

    // 关键：背景透明，透出下方主题化面板（修复暗色模式白底）
    backgroundColor: "transparent",

    title: {
      textStyle: { fontWeight: "600", fontSize: 14, color: ink }
    },

    dataRange: {
      itemWidth: 15,
      color: [mint, "#e2fbf3"]
    },

    toolbox: {
      color: [ink2, ink2, ink2, ink2],
      effectiveColor: mint
    },

    tooltip: {
      backgroundColor: surface,
      borderColor: line,
      borderWidth: 1,
      padding: [10, 14],
      extraCssText: "box-shadow: 0 4px 12px rgba(0,0,0,0.18); border-radius: 8px;",
      textStyle: { color: ink, fontSize: 13 },
      axisPointer: {
        type: "line",
        lineStyle: { color: line, width: 1, type: "dashed" },
        crossStyle: { color: mint },
        shadowStyle: { color: "rgba(1, 225, 168, 0.06)" }
      }
    },

    dataZoom: {
      dataBackgroundColor: well,
      fillerColor: "rgba(1, 225, 168, 0.15)",
      handleColor: mint
    },

    grid: { borderColor: well },

    categoryAxis: {
      axisLine: { lineStyle: { color: line } },
      axisTick: { show: false },
      axisLabel: { color: ink2, fontSize: 12 },
      splitLine: { show: false }
    },

    valueAxis: {
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: { color: ink2, fontSize: 12 },
      splitArea: { show: false },
      splitLine: { lineStyle: { color: [well], type: "dashed" } }
    },

    polar: {
      axisLine: { lineStyle: { color: line } },
      splitArea: { show: true, areaStyle: { color: ["rgba(250,250,250,0.06)", "rgba(200,200,200,0.04)"] } },
      splitLine: { lineStyle: { color: line } }
    },

    timeline: {
      lineStyle: { color: mint },
      controlStyle: { normal: { color: mint }, emphasis: { color: mintDim } },
      symbol: "circle",
      symbolSize: 5
    },

    bar: { itemStyle: { normal: { barBorderRadius: 4 }, emphasis: { barBorderRadius: 4 } } },

    line: { smooth: true, symbol: "circle", symbolSize: 6, lineStyle: { width: 2.5 } },

    k: {
      itemStyle: {
        normal: { color: crit, color0: mint, lineStyle: { color: crit, color0: mint } }
      }
    },

    scatter: { symbol: "circle", symbolSize: 5 },
    radar: { symbol: "circle", symbolSize: 4 },

    map: {
      itemStyle: {
        normal: { areaStyle: { color: "#e2fbf3" }, label: { textStyle: { color: ink } } },
        emphasis: { areaStyle: { color: mint } }
      }
    },

    gauge: {
      axisLine: { lineStyle: { color: [[0.2, mint], [0.8, "#3b82f6"], [1, crit]], width: 10 } },
      axisTick: { splitNumber: 10, length: 15, lineStyle: { color: "auto" } },
      splitLine: { length: 22, lineStyle: { color: "auto" } },
      pointer: { width: 5 }
    },

    textStyle: { fontFamily: "'Poppins', 'Helvetica Neue', Arial, sans-serif" }
  };
}

// 兼容历史的默认导出（首次求值）。推荐改用 buildMacarons() 以随主题刷新。
export default buildMacarons();
